/**
 * 登录遇到问题
 * */
import React, { Fragment, PureComponent } from 'react';
import { Modal } from 'antd';
import './LoginQuestion.scss';
import { _change_pwd_modal } from '../../../store/Action';
import { withRouter } from '../../WithRouterHOC';

const questionList = [
  {
    id: 1,
    icon: 'pwd',
    title: '忘记密码',
    desc: '通过注册手机号短信验证身份找回密码',
  },
];

class LoginQuestion extends PureComponent {
  state = {
    visible: false,
  };

  showModal = () => {
    this.setState({ visible: true });
  };
  hideModal = () => {
    this.setState({ visible: false });
  };
  // 跳转
  handleQuestion = (type) => {
    if (type === 1) {
      _change_pwd_modal({ type: 2, show: true });
    }
    this.hideModal();
  };

  render() {
    const { visible } = this.state;
    return (
      <Fragment>
        {/* 问题列表弹窗 */}
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title="登录遇到问题"
          footer={null}
          keyboard={false}
          maskClosable={false}
          onCancel={this.hideModal}
        >
          <div className="question-modal-content">
            <ul className="question-ul">
              {questionList.map((item) =>
                item.id !== 2 ? (
                  <li
                    key={item.id}
                    className="question-li"
                    onClick={() => this.handleQuestion(item.id)}
                  >
                    <div className={`item-icon ${item.icon}`} />
                    <div className="item-content">
                      <h4 className="item-title">{item.title}</h4>
                      <p className="item-desc">{item.desc}</p>
                    </div>
                    <div className="item-icon-go" />
                  </li>
                ) : null
              )}
            </ul>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(LoginQuestion, { withRef: true });
